// Permissions the frontend needs to name outside the route table.
//
// DISBURSEMENT_PERMISSIONS is the same pair as `DISBURSEMENT_PERMISSIONS` in
// `backend/services/permissions.py`, which `require_disbursement_access` checks
// on every endpoint that sends money out. A button that calls one of those
// endpoints is shown only to a user holding either, so the screen offers exactly
// what the API will accept. `tests/test_money_endpoints_require_a_permission.py`
// fails when the two lists differ.
export const DISBURSEMENT_PERMISSIONS = ["can_disburse", "can_approve_disbursement"];

// Who may approve or reject what the credit team signs off — a consolidation payout list,
// a top-up's net in hand. The same pair as `CREDIT_APPROVAL_PERMISSIONS` in
// `backend/services/permissions.py`, which `require_credit_approval_access` checks on the
// endpoints behind the Approvals page. The page, its navigation entry and those endpoints
// must refuse the same people; `tests/test_money_endpoints_require_a_permission.py` fails
// when the two lists differ, and `src/pages/Approvals.permissionGate.test.js` holds the
// page to them.
export const CREDIT_APPROVAL_PERMISSIONS = ["can_approve_credit", "page_sales"];

// Who may approve or reject the bank details a disbursement will be paid to. Credit only:
// `page_sales` opens the Approvals page for the other credit queues but not this one. The
// same single name as `BANK_DETAILS_APPROVAL_PERMISSIONS` in
// `backend/services/permissions.py`, which `require_bank_details_approval_access` checks on
// the bank-details endpoints. The Approvals page shows the Bank Details tab and its buttons
// only to a holder.
export const BANK_DETAILS_APPROVAL_PERMISSIONS = ["can_approve_credit"];

// Who may decide another user's disbursement request. The same single name as
// `DISBURSEMENT_APPROVER_PERMISSIONS` in `backend/services/permissions.py`, which
// `require_disbursement_approver_access` checks on approve and reject. Narrower than
// DISBURSEMENT_PERMISSIONS: `can_disburse` covers sending money within your own limit,
// not deciding someone else's request. The Approvals page shows the disbursement tab
// and its buttons only to a holder.
export const DISBURSEMENT_APPROVER_PERMISSIONS = ["can_approve_disbursement"];

// Who may open the Approvals page at all: a holder of either queue's permission. Each
// queue's tab and buttons are then gated on its own list, so the page never offers a
// button whose endpoint answers 403. Written out rather than spread, so a source scan
// can read it (`App.routeGates.test.js`); the backend test compares it with the union.
export const APPROVALS_PAGE_PERMISSIONS = [
  "can_approve_credit",
  "page_sales",
  "can_approve_disbursement",
];
